// ************** 在线备课讲义  ****************

// 获取题目推荐配置
export const CONFIG_GET_RECOMMEND_QUESTION_CONFIG = 'CONFIG_GET_RECOMMEND_QUESTION_CONFIG';
export const CONFIG_SET_RECOMMEND_QUESTION_CONFIG = 'CONFIG_SET_RECOMMEND_QUESTION_CONFIG';



// WEBPACK FOOTER //
// ./src/views/index/store/types/types_config.js